import styled from 'styled-components';
import { flexbox, alignItems, flexDirection } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const ModalWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  const { bgColor, customStyle, contextPos } = props;
  return `
    ${flexbox()};
    ${alignItems('center')};
    background: ${bgColor};
    color: ${colours.grey[900]};
    position: ${props.fixedParent ? 'absolute' : 'fixed'};
    left: ${props.positionX}px
    top: ${props.positionY}px
    border-radius: 8px;
    z-index: 99;
    box-shadow: 2px 2px 15px ${colours.grey[900]};
    ${props.modalWidth ? `width:${props.modalWidth}px;` : ''}
    min-height: 35px;
    cursor: default;
    border: 1px solid ${bgColor}
    ${customStyle}
    ${contextPos === 'right' ? `
    ::after {
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-right: 18px solid ${bgColor};
      width: 15px;
      position: fixed;
      top: ${props.positionY + 10}px;
      left: ${props.positionArrow - 17}px;
      content: ' '
    }
    ` : `
    ::after {
      width: 0; 
      height: 0; 
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;        
      border-bottom: 15px solid ${bgColor};
      ${props.fixedParent ? `
        position: absolute;
        top: -10px;
        left: ${props.positionArrowFixed ? `${props.positionArrowFixed}px` : '50%'};
        transform: translateX(-50%);
      ` : `
        position: fixed;
        top: ${props.positionY - 10}px;
        left: ${props.positionArrow - 8}px;
      `}
      content: ' '
    }`}

    &:hover {
        color: ${props.hoverTextColor ? props.hoverTextColor : colours.grey[900]};
    }`;
});

const Content = styled.div(() => `
  ${flexDirection('column')};
  width: 100%;
  border-radius: 8px;
`);

const ContentTheme = styled.div(() => `
  ${flexDirection('column')};
  width: 100%
  padding: 10px;
  color: white;
  border-radius: 8px;
`);

export { ModalWrapper, Content, ContentTheme };
